import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environment/environment';
import { HttpUtil } from '../../../shared/util/http.util';
import { Page } from '../../../shared/model/local/pagination/page';
import { Message } from '../model/message';
import { MessageDetails } from '../model/message-details';
import { MessagePageCriteria } from '../model/message-page-criteria';
import { ModifyMessage } from '../model/modify-message';
import { ResendMessage } from '../model/resend-message';

@Injectable({ providedIn: 'root' })
export class MessageApiService {
  private readonly apiUrl = environment.apiUrl + '/api/admin/messages';
  private readonly http = inject(HttpUtil);

  getPage(criteria: MessagePageCriteria): Observable<Page<Message>> {
    return this.http.get(`${this.apiUrl}/page`, criteria);
  }

  getById(id: number): Observable<MessageDetails> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  create(payload: ModifyMessage): Observable<MessageDetails> {
    return this.http.post(this.apiUrl, payload);
  }

  update(id: number, payload: ModifyMessage): Observable<MessageDetails> {
    return this.http.put(`${this.apiUrl}/${id}`, payload);
  }

  delete(id: number): Observable<void> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  sendNow(id: number): Observable<MessageDetails> {
    return this.http.post(`${this.apiUrl}/${id}/send`, {});
  }

  resend(id: number, payload: ResendMessage): Observable<MessageDetails> {
    return this.http.post(`${this.apiUrl}/${id}/resend`, payload);
  }
}
